// AC OPERATIONAL DASHBOARD ACTIONS
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getMyBranchRequest, getTxnErrors, getInquiriescount} from 'services/ac-opsDashboard.service'
import {type ITxnErrorsReqPayload, type IFetchCountParams} from './ac-opsdash.types'

export const fetchMyBranchRequest = createAsyncThunk(
    'fetchMyBranchRequest',
    async (payload: string, {rejectWithValue}) => {
        try {
            const finalStatus = {
                carrier: payload
            }
            const {data} = await getMyBranchRequest(finalStatus)
            if (data?.successFlag) {
                return data.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const getTxnErrorsAction = createAsyncThunk(
    'getTxnErrorsAction',
    async (payload: ITxnErrorsReqPayload, {rejectWithValue}) => {
        try {
            const {data} = await getTxnErrors(payload)

            if (data?.successFlag) {
                return data.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)

export const fetchInquiriesCount = createAsyncThunk(
    'fetchInquiriesQueryCount',
    async ({date, carrier}: IFetchCountParams, {rejectWithValue}) => {
        try {
            const request = {date, carrier}
            const {data} = await getInquiriescount(request)
            if (data?.successFlag) {
                return data.response
            } else {
                return rejectWithValue({
                    error: {text: 'Data unavailable.'}
                })
            }
        } catch (err: any) {
            return rejectWithValue({
                error: {
                    text: 'Data unavailable.',
                    code: '500'
                }
            })
        }
    }
)
